import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { SearchActivityEvents } from 'generated/graphql';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import {
  activityEventExpantionStateSelector, ActivityEventItemExpansionState,
  setActivityItemExpansionState
} from '../../../_state/activity-event-expansion.state';

@Component({
  selector: 'app-mass-add-follow-up-event',
  templateUrl: './mass-add-follow-up-event.component.html'
})

export class ASMassAddFollowUpFlagEventComponent extends
  WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  showFullText = false;

  get payload() {
    return this.item?.payload;
  }

  /**
   *
   */
  constructor(
    private store: Store<ActivityEventItemExpansionState>
  ) {
    super();
  }

  ngOnInit() {
    this.store.select(
      activityEventExpantionStateSelector({ itemId: this.item.id })
    ).pipe(
      takeUntil(this.disposer)
    ).subscribe(
      (showFullText) => {
        this.showFullText = showFullText;
      });
  }

  setShowFullText(value: boolean) {
    this.store.dispatch(
      setActivityItemExpansionState({
        itemId: this.item.id,
        expanded: value
      })
    );
  }
}
